<template>
  <van-tabbar :value="currentActive" active-color="#ffb600" @change="tabChangeFn">
    <van-tabbar-item >
      <span>首页</span>
      <template #icon="props">
        <img :src="props.active ? homeicon.active : homeicon.inactive" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item>
      <span>订单中心</span>
      <template #icon="props">
        <img :src="props.active ? ordericon.active : ordericon.inactive" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item>
      <span>我的</span>
      <template #icon="props">
        <img :src="props.active ? myicon.active : myicon.inactive" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
import { Login } from "@/api/login.js";
export default {
  props: {
    active: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      homeicon: {
        active: require("@/assets/images/home_active.png"),

        inactive: require("@/assets/images/home_inactive.png"),
      },
      ordericon: {
        active: require("@/assets/images/order_active.png"),
        inactive: require("@/assets/images/order_inactive.png"),
      },
      myicon: {
        active: require("@/assets/images/my_active.png"),
        inactive:require( "@/assets/images/my_inactive.png"),
      },
    };
  },
  computed: {
    currentActive() {
      return this.active;
    }
  },
  methods: {
    async tabChangeFn(index) {
      console.log(index, "切换标签");
      let isCheck = await Login.verifyLogin();
      if (!isCheck) {
        return
      }
      this.$emit('update:active', index);
      if (index == 0) {
        this.$router.push({
          name: "home",
        });
      } else if (index == 1) {
        this.$router.push({
          name: "orderList",
        });
      } else if (index == 2) {
        this.$router.push({
          name: "my",
        });
      }
    },
  },
};
</script>

<style scoped>
/* 可以在这里添加自定义样式 */
</style>


// WEBPACK FOOTER //
// src/components/tabBar.vue